import API from 'app/utils/apiClient';


const getCurations = (type = 'OTR') => API.get(`/curations/${type}/`);

const getCurationsBanners = (type = 'OTR') => API.get(`/curations/${type}/banners/`);


export default {
  getCurations,
  getCurationsBanners,
};



// WEBPACK FOOTER //
// ./src/app/apis/curation.js